'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActiveLimit = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Money = require('../../../components/Money');

var _Money2 = _interopRequireDefault(_Money);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActiveLimit = function ActiveLimit(_ref) {
  var amount = _ref.amount,
      currency = _ref.currency,
      period = _ref.period;
  return _react2.default.createElement(
    'div',
    { className: 'limit-info-container' },
    amount && _react2.default.createElement(
      'div',
      { className: 'active-limit-content signup', key: Math.random() },
      _react2.default.createElement(
        'div',
        { className: 'limit-name' },
        period
      ),
      _react2.default.createElement(
        'div',
        { className: 'active-limit-amount' },
        _react2.default.createElement(_Money2.default, { decimals: false, value: amount, currency: currency })
      )
    )
  );
};

exports.ActiveLimit = ActiveLimit;